
import { assertValue } from 'src/shared/NullUtil';
import { FileBlockProcessor } from 'src/shared/wysiwyg/ultra/UltraBlockProcessing/FileBlockProcessor';
import {
    KnowledgeCheckBlockProcessor
} from 'src/shared/wysiwyg/ultra/UltraBlockProcessing/KnowledgeCheckBlockProcessor';
import { UnsupportedBlockError } from 'src/shared/wysiwyg/ultra/UltraBlockProcessing/UnsupportedBlockError';
import { VideoStudioBlockProcessor } from 'src/shared/wysiwyg/ultra/UltraBlockProcessing/VideoStudioBlockProcessor';

import { HTMLBlockProcessor } from './HTMLBlockProcessor';
import { QuillEditorBlockProcessor } from './QuillEditorBlockProcessor';
import { IBlockProcessor, IEditorBlock } from './UltraBlockInterfaces';

export class BlockProcessorService {
    private readonly processors: { [key: string]: IBlockProcessor<any> };
    protected readonly container: HTMLElement;

    constructor(container: HTMLElement) {
        this.container = container;
        this.processors = {
            'text': new QuillEditorBlockProcessor(container),
            'conversion': new QuillEditorBlockProcessor(container),
            'html': new HTMLBlockProcessor(container),
            'knowledgeCheck': new KnowledgeCheckBlockProcessor(container),
            'videoStudio': new VideoStudioBlockProcessor(container),
            'file': new FileBlockProcessor(container)
        };
    }

    public async processBlock(block: IEditorBlock): Promise<string> {
        try {
            assertValue(block, 'Block is required');
            assertValue(block.id, 'Block ID is required');
            assertValue(block.block, 'Block info is required');
            const processor = this.processors[block.block.type];
            if (!processor) {
                console.warn(`Unknown block type: ${block.block.type}`);
                return '';
            }
            return await processor.process(block.block);
        } catch (error) {
            // don't show errors for non-supported functions.
            if (!(error instanceof UnsupportedBlockError)) {
                console.warn(error);
            }
            return '';
        }
    }

    public async processEditorBlockContent(blocks: IEditorBlock[]): Promise<string> {
        const processedBlocks = await Promise.all(blocks.map((block) => this.processBlock(block)));
        return processedBlocks.join('');
    }
}
